import { CollectionNameType } from '@coolblue-development/next-patterns/core';
import { PromoIcon } from '@features/product/typings';

export default function legacyPromotionalContentFactory(
  promoIconData: PromoIcon | undefined,
  name: string,
  showModal?: boolean
) {
  const detailsModal = showModal &&
    promoIconData?.displayText &&
    promoIconData.explanation && {
      details: {
        title: promoIconData.displayText,
        explanation: promoIconData.explanation
      }
    };

  const promoIcon = promoIconData?.image?.id &&
    promoIconData.image && {
      altText: name,
      image: {
        id: promoIconData.image.id,
        collectionName: promoIconData.image.collectionName as CollectionNameType
      },
      ...detailsModal
    };

  // Only show the promoLabel if there is no promoIcon
  const promoLabel =
    !promoIconData?.image?.id && promoIconData?.displayText
      ? {
          label: promoIconData.displayText,
          ...detailsModal
        }
      : undefined;

  if (!promoIcon && !promoLabel) return undefined;

  return { ...(promoIcon && { promoIcon }), ...(promoLabel && { promoLabel }) };
}
